import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionList } from 'components/ActionList'
import Box, { BoxType } from 'components/Box'
import { Button, TYPE as ButtonType } from 'components/Button'
import { Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import Icon from 'components/Icon'
import { InfoBox, InfoBoxItem } from 'components/InfoBox/InfoBox'
import { List, ListItem } from 'components/List'
import ListHeader from 'components/ListHeader'
import Section, {
  SectionColors,
  SectionType,
  Size,
} from 'components/Section/Section'
import Style from 'components/Style'
import { Timeline, TimelineItem } from 'components/Timeline'
import { Colour } from 'components/variables'
import { getCdnUrl } from '../../data/api/cdn'
import { ContentProps, EntryProps } from '../../data/entries/types'
import { City } from '../../data/models/funnelOrder/cities'
import { inControlOptions } from '../../data/models/funnelOrder/days'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import { getMinIncludedCities } from '../../data/models/funnelOrder/includedCities'
import { Theme, ThemeTypes } from '../../data/models/funnelOrder/theme'
import { getSiteCountryICC2, SiteCountry } from '../../data/models/locale'
import { getClient } from '../../data/openapi'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import Calendar from '../../elements/Calendar'
import IfCountry from '../../elements/conditionals/IfCountry'
import FlyIncludedCities from '../../elements/excluded/FlyIncludedCities'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import Loader from '../../elements/Loader'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import PriceErrorModal from '../../elements/modals/PriceErrorModal'
import PriceErrorNotification from '../../elements/modals/PriceErrorNotification'
import BucketListTrigger from '../../elements/triggers/bucket-list/BucketListTrigger'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import Airport from '../funnel/customise/options/airport'
import Days from '../funnel/customise/options/days'
import LockedAirport from '../funnel/customise/options/lockedAirport'
import People from '../funnel/customise/options/people'
import RoomType from '../funnel/customise/options/roomType'
import { QueryKey } from '../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import { LoaderPage } from '../loader'
import DisplayContent from '../shared/content'
import Page from '../shared/page_wrapper'
import BasicInfo from './components/basicInfo'
import HowItWorks from './components/entries/howItWorks'
import FAQ from './components/faq'

interface BucketListProps extends EntryProps {
  theme: Theme
  total: number
  patternImage: string
  includedCities: City[]
  country: SiteCountry
  destination: destinationEnum

  setIncludedCities(cities: City[]): void
}

interface BucketListState {
  loading: boolean
  cities: City[]
}

class BucketListPage extends React.Component<
  BucketListProps & CustomiseWrapperInnerProps,
  BucketListState
> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement

  constructor(props: BucketListProps & CustomiseWrapperInnerProps) {
    super(props)
    this.state = {
      loading: true,
      cities: [],
    }
  }

  public componentDidMount() {
    this.setCountries(true)
  }

  public componentDidUpdate(
    props: BucketListProps & CustomiseWrapperInnerProps,
  ) {
    if (props.country !== this.props.country) {
      this.setCountries()
    }
  }
  public render() {
    const {
      entry,
      match,
      prices,
      loading,
      airports,
      destination,
      includedCities,
      setIncludedCities,
    } = this.props
    const { loading: pageLoading } = this.state

    if (pageLoading) {
      return <LoaderPage />
    }

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    const isNextStepEnabled = this.isNextStepEnabled()

    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
        whiteBackground
      >
        <Hero
          blurMobile
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarColored()}
              firstLine={
                <DisplayContent contentKey="1-info-top">3 - 14</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="1-info-bottom">
                  Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={
                entry.theme === Theme.fly
                  ? SRPRS.aeroplaneColored
                  : SRPRS.carColored
              }
              firstLine={
                <DisplayContent contentKey="2-info-top">
                  destination
                </DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  unknown
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarkerColored}
              iconProps={{
                width: '34',
                height: '44',
                viewBox: '0 0 44 34',
                fill: 'none',
              }}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <BasicInfo
          type={SectionType.transparentWhite}
          detailsScroll={this.handleDetailsScroll}
          infoScroll={this.handleInfoScroll}
        />
        <Section
          type={SectionType.white}
          size={Size.m}
          noBottomPadding
          decorationImages={[
            {
              width: 456,
              src: getCdnUrl(`blue-bg-pattern-right.png`),
              right: 0,
              top: -300,
              desktopOnly: true,
              isCovered: true,
            },
            {
              width: 300,
              src: getCdnUrl(`blue-bg-pattern-left.png`),
              left: 0,
              top: 360,
              desktopOnly: true,
            },
          ]}
        >
          <div ref={this.setDetailsRef} />
          <Section
            type={SectionType.solidTurquoise}
            size={Size.s}
            color={SectionColors.glory}
          >
            <Style margin={[[0, 0, 20, 0]]}>
              <Timeline direction="vertical" numbers>
                <TimelineItem>
                  <Heading level={3}>
                    <DisplayContent contentKey="include-cities-heading">
                      Which cities will it be?
                    </DisplayContent>
                  </Heading>
                  <p>
                    <DisplayContent contentKey="include-cities-subheading">
                      Do you just strike 2 out of contention of all 5? You
                      decide.
                    </DisplayContent>
                  </p>
                  <FlyIncludedCities
                    solid
                    max={50}
                    destination={destination}
                    includedCities={includedCities}
                    setIncludedCities={setIncludedCities}
                  />

                  <BucketListTrigger colour={Colour.pink} showLength={1}>
                    <p>
                      <DisplayContent contentKey="over-1-cities">
                        Please select 2 more cities
                      </DisplayContent>
                    </p>
                  </BucketListTrigger>
                  <BucketListTrigger colour={Colour.pink} showLength={2}>
                    <p>
                      <DisplayContent contentKey="over-2-cities">
                        Please select 1 more city
                      </DisplayContent>
                    </p>
                  </BucketListTrigger>
                  <BucketListTrigger colour={Colour.mint} showLength={3}>
                    <p>
                      <DisplayContent contentKey="cities-list-complete">
                        Nice! Now you can select more cities or go next step
                      </DisplayContent>
                    </p>
                  </BucketListTrigger>
                </TimelineItem>
                <TimelineItem>
                  <ActionList>
                    <People />
                    <Days options={inControlOptions} />
                    <RoomType />
                    <Airport {...{ airports }} />
                    <Style margin={[[40, 0, 0, 0]]}>
                      <List isText>
                        <ListItem>
                          <DisplayContent contentKey={`timeline-list-item-1`}>
                            timeline item
                          </DisplayContent>
                        </ListItem>
                        <ListItem>
                          <DisplayContent contentKey={`timeline-list-item-2`}>
                            timeline item
                          </DisplayContent>
                        </ListItem>
                        <ListItem>
                          <DisplayContent contentKey={`timeline-list-item-3`}>
                            timeline item
                          </DisplayContent>
                        </ListItem>
                      </List>
                    </Style>
                  </ActionList>
                </TimelineItem>
                <TimelineItem>
                  <Box fullWidthMobile>
                    <Calendar
                      isDisabled={includedCities.length < 3}
                      actionList
                      hideTrigger
                      showCheapest={true}
                      prices={prices}
                      loading={loading}
                    />
                  </Box>
                </TimelineItem>
              </Timeline>
            </Style>
            <PersonModal />
          </Section>
        </Section>
        <FunnelFooter
          hideTotalWhenDisabled
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={!isNextStepEnabled}
        />
        <GiftcardModal />
        <div ref={this.setInfoRef} />
        {this.renderFlavourBox(entry.page.content)}
        {this.renderHowItWorks()}
        <Section type={SectionType.white} size={Size.m}>
          <ListHeader noMarginBottom>
            <Button
              cutOff="none"
              type={ButtonType.plain}
              onClick={this.handleDetailsScroll}
            >
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ size={Size.m} />
        <PriceErrorNotification
          colour={entry.colour}
          forceHide={includedCities.length < 3}
        />
      </Page>
    )
  }

  private renderHowItWorks() {
    return (
      <HowItWorks
        backgroundImageLink={'bucketlist-heading-bg.jpg'}
        boxTypeColor={BoxType.gloryColorHeaders}
      />
    )
  }

  private renderFlavourBox(content?: ContentProps) {
    const renderExplain = (leftOrRight: 'left' | 'right') => {
      let length = 5
      if (content) {
        if (leftOrRight === 'left' && content.explainLeft) {
          length = content.explainLeft
        }
        if (leftOrRight === 'right' && content.explainRight) {
          length = content.explainRight
        }
      }
      const output = []
      for (let i = 1; i <= length; i++) {
        output.push(
          <ListItem dash key={i}>
            <DisplayContent contentKey={`explain-${leftOrRight}-text-${i}`}>
              {`explain-${leftOrRight}-text-${i}`}
            </DisplayContent>
          </ListItem>,
        )
      }
      return output
    }

    return (
      <Section
        type={SectionType.photo}
        size={Size.m}
        src={{
          blurMobile: true,
          src: getCdnUrl('bucket-full-section-bg-768.jpg'),
          src1024: getCdnUrl('bucket-full-section-bg-1024.jpg'),
          src1280: getCdnUrl('bucket-full-section-bg-1280.jpg'),
          src1600: getCdnUrl('bucket-full-section-bg-1600.jpg'),
          src1920: getCdnUrl('bucket-full-section-bg-1920.jpg'),
        }}
      >
        <Grid
          nrCols={[1, 2]}
          rowGap={[GridGap.m]}
          className={'grid-white-text'}
        >
          <div>
            <Heading level={4}>
              <DisplayContent contentKey="explain-left-heading">
                What we do for you
              </DisplayContent>
            </Heading>
            <List>{renderExplain('left')}</List>
          </div>
          <div>
            <Heading level={4}>
              <DisplayContent contentKey="explain-right-heading">
                What you need to arrange yourself
              </DisplayContent>
            </Heading>
            <List>{renderExplain('right')}</List>
          </div>
        </Grid>
      </Section>
    )
  }

  private isNextStepEnabled(): boolean {
    const { includedCities, total } = this.props
    return (
      getMinIncludedCities() <= includedCities.length &&
      !!total &&
      !isNaN(total)
    )
  }

  private setCountries = (mount?: boolean) => {
    getClient()
      .then(client =>
        client.apis.bookings.bookings_theme_cities({
          theme: 'bucket-list',
          type: ThemeTypes.fly,
          site_country: getSiteCountryICC2(this.props.country),
        }),
      )
      .then(response => response.body)
      .then(cities => {
        this.setState({ cities, loading: false }, () => {
          if (mount) {
            const hash = window.location.hash
            if (hash !== undefined && hash === '#steden') {
              setTimeout(() => {
                if (this.detailsSection) {
                  this.detailsSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                  })
                }
              }, 2000)
            } else {
              window.scrollTo(0, 0)
            }
          }
        })
      })
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private cityIncluded = (cities: City[], city: City) => {
    return cities.map(x => x.id).includes(city.id)
  }

  private handleChange = (value: any, checked: boolean) => {
    const cities = [...this.props.includedCities]
    const filteredCities = this.state.cities.filter(x => x.id === Number(value))
    const city = filteredCities.length > 0 ? filteredCities[0] : null

    if (city !== null) {
      if (this.cityIncluded(cities, city) && checked) {
        const index = cities.map(x => x.id).indexOf(city.id)
        cities.splice(index, 1)
      }
      if (!this.cityIncluded(cities, city) && !checked) {
        cities.push(city)
      }

      this.props.setIncludedCities(cities)
    }
  }
}

const ConnectedBucketListPage = connect(
  (state: AppState) => ({
    theme: state.funnelOrder.theme,
    patternImage: state.page.patternImage,
    total: state.funnelOrder.total,
    includedCities: state.funnelOrder.includedCitiesIds,
    destination: state.funnelOrder.destination,
    country: state.locale.country,
  }),
  dispatch => ({
    setIncludedCities: (cities: City[]) => {
      dispatch(actions.change('funnelOrder.includedCitiesIds', cities))
    },
  }),
)(BucketListPage)

export default withAirportsAndPrices<EntryProps>(ConnectedBucketListPage, [
  QueryKey.month,
  QueryKey.year,
])
